import React from "react";
import PropTypes from "prop-types";

// Components
import { Modal } from "components/Modals/Modal";
import { Text } from "components/Text/Text";
import { ButtonPrimary } from "components/Buttons/Buttons";

// CSS
import styles from "./claim-letter-modal.module.scss";

export const ClaimLetterModal = ({
    handleClaimLetter,
    isClaimingLetter,
    isOpen,
    onClose,
    promotionData = null,
}) => {
    if (!promotionData) {
        return null;
    }

    const {
        title,
        bannerPhoto,
        campaign,
        cta,
        details,
        finePrint,
        organization,
        partner,
    } = promotionData;

    return (
        <Modal
            centered="true"
            className={styles.claimLetterModal}
            headerText={title}
            onClose={onClose}
            onHide={onClose}
            show={isOpen}
            size="md"
        >
            <div className={styles.content}>
                {bannerPhoto && (
                    <img
                        src={bannerPhoto}
                        alt={`${organization?.name || partner} logo`}
                        className={styles.bannerImage}
                    />
                )}
                {campaign?.description && (
                    <Text classes={styles.description}>
                        {campaign.description}
                    </Text>
                )}
                {campaign?.photo && (
                    <img
                        src={campaign.photo}
                        alt={campaign.name || title}
                        className={styles.photo}
                    />
                )}
                {details?.features && details.features.length > 0 && (
                    <ul className={styles.features}>
                        {details.features.map((feature, i) => (
                            <li key={i}>
                                <Text>{feature}</Text>
                            </li>
                        ))}
                    </ul>
                )}
                {details?.gratitude && (
                    <Text classes={styles.gratitude}>{details.gratitude}</Text>
                )}
                {cta?.buttonText && (
                    <ButtonPrimary
                        classes={styles.button}
                        isLoading={isClaimingLetter}
                        onClick={handleClaimLetter}
                        text={cta.buttonText}
                    />
                )}
                {finePrint && (
                    <Text classes={styles.finePrint}>{finePrint}</Text>
                )}
            </div>
        </Modal>
    );
};

ClaimLetterModal.propTypes = {
    handleClaimLetter: PropTypes.func.isRequired,
    isClaimingLetter: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    promotionData: PropTypes.shape({
        title: PropTypes.string,
        bannerPhoto: PropTypes.string,
        campaign: PropTypes.shape({
            description: PropTypes.string,
            name: PropTypes.string,
            photo: PropTypes.string,
        }),
        cta: PropTypes.shape({
            buttonText: PropTypes.string,
        }),
        details: PropTypes.shape({
            features: PropTypes.arrayOf(PropTypes.string),
            gratitude: PropTypes.string,
        }),
        finePrint: PropTypes.string,
        organization: PropTypes.shape({
            name: PropTypes.string,
        }),
        partner: PropTypes.string,
    }),
};
